import { __assign, __awaiter, __generator, __spreadArray } from "tslib";
import { WebviewBridge } from './webview-bridge';
export var webviewClient = function (BaseClientConstructor_1, baseParams_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([BaseClientConstructor_1, baseParams_1], args_1, true), void 0, function (BaseClientConstructor, baseParams, options) {
        var _a, bridgeTimeout, webviewBridge, params, apiKey, _b, instance;
        if (options === void 0) { options = {}; }
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = options.bridgeTimeout, bridgeTimeout = _a === void 0 ? 3000 : _a;
                    webviewBridge = new WebviewBridge();
                    params = baseParams;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Promise.race([
                            webviewBridge.setup(),
                            new Promise(function (_, reject) {
                                setTimeout(function () { return reject(new Error('timeout reached')); }, bridgeTimeout);
                            }),
                        ])];
                case 2:
                    _c.sent();
                    apiKey = webviewBridge.getApiKey();
                    params = __assign(__assign(__assign({}, baseParams), (apiKey ? { apiKey: apiKey } : {})), { getClientParametersOverride: function () { return webviewBridge.getSharedParameters() || {}; } });
                    return [3 /*break*/, 4];
                case 3:
                    _b = _c.sent();
                    return [3 /*break*/, 4];
                case 4:
                    instance = new BaseClientConstructor(params);
                    instance.on('message', function (_a) {
                        var type = _a.type;
                        if (type === 'event') {
                            webviewBridge.notifyEventHappened();
                        }
                    });
                    return [2 /*return*/, instance];
            }
        });
    });
};
//# sourceMappingURL=webview-client.js.map